import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ name: 'ignoreNextLine'})
export class IgnoreNextLinePipe implements PipeTransform  {
  constructor() {}
  transform(value) {
    return value?.toString().replace(/\n/g, '') || '';
  }
}